// extracted by mini-css-extract-plugin
module.exports = {"welcomeAlert":"Alert_welcomeAlert__nDAdN","icon":"Alert_icon__1feOx"};